import React from 'react';
import './ToolTip.scss';

interface IProps {
    children: any;
    message: string;
    hideMobile?: boolean;
}

const ToolTip = ({ children, message, hideMobile }: IProps) => {
    return (
        <div className="a-tooltip">
            {children}
            <div
                className={`a-tooltip__message ${hideMobile ? 'hide__mobile' : ''}`}
            >
                {message}
            </div>
        </div>
    );
};

export default ToolTip;
